import React from "react";
import TaperView from "./TaperView";
import ManagerView from "./ManagerView";

function SelectionScreen() {
  const [selection, setSelection] = React.useState(
    localStorage.getItem("SLMRole")
  );

  return selection === "taper" ? (
    <div>
      <button
        className="back-button-main"
        onClick={() => {
          setSelection("");
          localStorage.setItem("SLMRole", "");
        }}
      >
        Teippaus
      </button>
      <TaperView />
    </div>
  ) : selection === "manager" ? (
    <div>
      <button
        className="back-button-main"
        onClick={() => {
          setSelection("");
          localStorage.setItem("SLMRole", "");
        }}
      >
        Ylläpito
      </button>
      <ManagerView />
    </div>
  ) : (
    <div>
      <p className="view-select-title">Valitse näkymä</p>
      <div className="view-select-button-container">
        <button
          onClick={() => {
            setSelection("taper");
            localStorage.setItem("SLMRole", "taper");
          }}
        >
          Teippaus
        </button>
        <button
          onClick={() => {
            setSelection("manager");
            localStorage.setItem("SLMRole", "manager");
          }}
        >
          Ylläpito
        </button>
      </div>
    </div>
  );
}
export default SelectionScreen;
